module.exports = __webpack_public_path__ + "media/packs/images/flags/IN-731f8203b66171acf37e1cdac6e6f0aa.svg";